import React from "react";
import ReactDOM from "react-dom/client";
import ReactGA from "react-ga4";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

import { COOKIE_CONSENT_KEY, COOKIE_CONSENT_VALUES } from "@constants/cookies";

import { initializeFirebaseSW } from "./config/firebase";
import { persistor, store } from "./store/index";
import { getCookie } from "./utils/common.utils";
import App from "./App";
import { GOOGLE_ANALYTICS_KEY } from "./app.config";

import "bootstrap/dist/css/bootstrap.min.css";
import "./styles.scss";

const cookieConsent = getCookie(COOKIE_CONSENT_KEY);

if (cookieConsent === COOKIE_CONSENT_VALUES.ALL) {
  ReactGA.initialize(GOOGLE_ANALYTICS_KEY);
}

initializeFirebaseSW();

import "@/config/sentry";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate persistor={persistor} loading={null}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);
